import React from 'react'
import '../../styles/common/professional-loader.scss'

// Skeleton for Table
export const TableSkeleton = ({ rows = 5, columns = 5 }) => {
  return (
    <div className="skeleton-table">
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            {Array.from({ length: columns }).map((_, i) => (
              <th key={i} style={{ padding: '1rem' }}>
                <div className="skeleton-loader skeleton-text" style={{ width: '80%' }}></div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <td key={colIndex} style={{ padding: '1rem' }}>
                  <div className="skeleton-loader skeleton-text"></div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

// Skeleton for Cards
export const CardSkeleton = ({ count = 3 }) => {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem' }}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} style={{ background: 'white', padding: '1.5rem', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <div className="skeleton-loader skeleton-avatar" style={{ marginBottom: '1rem' }}></div>
          <div className="skeleton-loader skeleton-title"></div>
          <div className="skeleton-loader skeleton-text"></div>
          <div className="skeleton-loader skeleton-text"></div>
          <div className="skeleton-loader skeleton-button" style={{ marginTop: '1rem' }}></div>
        </div>
      ))}
    </div>
  )
}

// Skeleton for List Items
export const ListSkeleton = ({ count = 5 }) => {
  return (
    <div>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '1rem', background: 'white', marginBottom: '0.5rem', borderRadius: '8px' }}>
          <div className="skeleton-loader skeleton-avatar"></div>
          <div style={{ flex: 1 }}>
            <div className="skeleton-loader skeleton-title" style={{ width: '60%' }}></div>
            <div className="skeleton-loader skeleton-text" style={{ width: '80%' }}></div>
          </div>
          <div className="skeleton-loader skeleton-button"></div>
        </div>
      ))}
    </div>
  )
}

// Skeleton for Roster Details (Person Cards)
export const PersonCardSkeleton = ({ count = 6 }) => {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '1.5rem' }}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} style={{ display: 'flex', gap: '1rem', padding: '1.5rem', background: 'white', borderRadius: '12px', border: '2px solid #e5e7eb' }}>
          <div className="skeleton-loader" style={{ width: '100px', height: '100px', borderRadius: '8px' }}></div>
          <div style={{ flex: 1 }}>
            <div className="skeleton-loader skeleton-title" style={{ width: '70%', marginBottom: '0.5rem' }}></div>
            <div className="skeleton-loader skeleton-text" style={{ width: '50%', marginBottom: '0.5rem' }}></div>
            <div className="skeleton-loader skeleton-text" style={{ width: '60%', marginBottom: '0.5rem' }}></div>
            <div className="skeleton-loader skeleton-text" style={{ width: '40%' }}></div>
          </div>
        </div>
      ))}
    </div>
  )
}

// Generic Skeleton Loader
const SkeletonLoader = ({ type = 'text', width = '100%', height, style = {} }) => {
  const skeletonClass = `skeleton-loader skeleton-${type}`

  return (
    <div
      className={skeletonClass}
      style={{
        width,
        height: height || (type === 'text' ? '16px' : type === 'title' ? '24px' : '100px'),
        ...style
      }}
    />
  )
}

export default SkeletonLoader
